import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  iam: {
    url: 'https://iaml3.viessmann-climatesolutions.com',
    auth: {
      baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
      appId: 'viparts',
    },
  },
  backend: {
    apiKey: 'rgLTQ9O+E3z-ow-b8vyIdRpUG',
    url: 'https://gateway-dev.viessmann-climatesolutions.com/viparts-api',
    resourcesUrl: 'https://gateway-dev.viessmann-climatesolutions.com/resources',
    accountUrl: 'https://account-integration.viessmann-climatesolutions.com',
    vibooksUrl: 'https://vibooks-integration.viessmann-climatesolutions.com',
    shopUrl: 'https://shop-test.viessmann-climatesolutions.com',
    partnerPortalUrl: 'https://partnerportal-staging.viessmann-climatesolutions.com',
    blockRules:
      '[{"trigger": {"url-filter": ".*gtm.js.*","resource-type": ["script"]},"action": {"type": "block"}},{"trigger": {"url-filter": ".*instana.io.*","resource-type": ["script"]},"action": {"type": "block"}}]',
  },
  noOrderSalesOrgs: ['8100', '9900'],
  showSuccessorsPredecessors: true,
  checkNetPriceRole: true,
  selfUrl: 'http://localhost:4200',
  maintenanceId: '4c7bfr67zhmy',
  checkoutPollingInterval: 300000, // 5 minutes
  firebase: {
    apiKey: 'AIzaSyAnxNLQmSJZhmNzswtgTlPwBNKR1skp4pc',
    authDomain: 'vi-its-viparts-test.firebaseapp.com',
    projectId: 'vi-its-viparts-test',
    storageBucket: 'vi-its-viparts-test.firebasestorage.app',
    messagingSenderId: '953820174837',
    appId: '1:953820174837:web:9ef61402bf66da32e928bc',
    measurementId: 'G-J6Q4BQ49ZY',
  },
};
